export default __webpack_public_path__ + "static/media/lesson-pic4.c7fbd15f.jpg";